/**
 * @author Arul Vivek
 */
import service from '../Common/'
import constants from '../../../settings/shared/constants'


function _constructHeader(storageId, rootFolder) {
    let jwtToken = localStorage.getItem('accessToken');
    let headerObj = {};
    if (storageId === "" || storageId === null) {
        headerObj = {
            'Content-Type': 'application/json', 'Authorization': 'Bearer ' + jwtToken
        }
    } else {
        if (storageId !== null && storageId !== undefined) {
            headerObj = {
                "storage-id": storageId,
                "root-folder": rootFolder,
                'Content-Type': 'application/json', 'Authorization': 'Bearer ' + jwtToken
            }
        }
    }
    return headerObj

}

function new_runInit() {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + jwtToken }

    return service({
        url: constants.api.run.newRun,
        method: 'POST',
        headers: headers,
        data: {}
    });
}

function getAllRuns(udata) {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + jwtToken }
    return service({
        url: constants.api.run.getAllrun,
        method: 'POST',
        headers: headers,
        data: udata
    });
}

function getRunbySize(udata, start, end) {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + jwtToken }
    return service({
        url: constants.api.run.GetRunbySize + "?page=" + start + "&size=" + end,
        method: 'POST',
        headers: headers,
        data: udata
    });
}

function getAllRunTimesImage() {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + jwtToken }
    return service({
        url: constants.api.run.getRunTimeImageList,
        method: 'GET',
        headers: headers,
        data: ''
    });
}

function getRunbySearch(udata, start, end) {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + jwtToken }
    return service({
        url: constants.api.run.GetRunbySearch + "?page=" + start + "&size=" + end,
        method: 'POST',
        headers: headers,
        data: udata
    });
}

function runSubmit(runData) {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + jwtToken }
    return service({
        url: constants.api.run.postNewrun,
        method: 'POST',
        headers: headers,
        data: runData
    });
}
function PostRerun(rerunData, rundbid, from) {
    let jwtToken = localStorage.getItem('accessToken');
    let rurl = ''
    if (from === 'rerun') {
        rurl = constants.api.run.postrerun + "?id=" + rundbid;
    }
    else {
        rurl = constants.api.run.postrerun;
    }
    let headers = { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + jwtToken }
    return service({
        url: rurl,
        method: 'POST',
        headers: headers,
        data: rerunData
    });
}

function cancelJob(jobPayload) {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + jwtToken }
    return service({
        url: constants.api.run.cancelJob,
        method: 'POST',
        headers: headers,
        data: jobPayload
    });
}

function removeJob(RemoveJobdto) {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + jwtToken }
    return service({
        url: constants.api.run.removeJob,
        method: 'POST',
        headers: headers,
        data: RemoveJobdto
    });
}

function createTags(id, tags) {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + jwtToken }
    return service({
        url: constants.api.run.createTag + id,
        method: 'POST',
        headers: headers,
        data: tags
    });
}

function downloadFile(filename, rid, type) {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + jwtToken }
    return service({
        url: constants.api.run.downloadFile + "?fileName=" + filename + "&runId=" + rid + "&type=" + type,
        method: 'GET',
        headers: headers,
        data: ''
    });
}

function GetChats(id) {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + jwtToken }
    return service({
        url: constants.api.run.getPostChat + id,
        method: 'GET',
        headers: headers,
        data: ''
    });
}

function GetMessages(jobId) {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + jwtToken }
    return service({
        url: constants.api.run.getMessages + jobId,
        method: 'GET',
        headers: headers,
        data: ''
    });
}

function ChatUpdateReadStatus(chatData) {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + jwtToken }
    return service({
        url: constants.api.run.updateReadStatus,
        method: 'PUT',
        headers: headers,
        data: chatData
    });
}

function GetmessageCount(start, end) {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + jwtToken }
    return service({
        url: constants.api.run.getchatCount + "?page=" + start + "&size=" + end,
        method: 'GET',
        headers: headers,
        data: ''
    });
}

function GetmessageOnScroll(jobId, start, end) {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + jwtToken }
    return service({
        url: constants.api.run.getMessagesScroll + jobId + "/scroll" + "?page=" + start + "&size=" + end,
        method: 'GET',
        headers: headers,
        data: ''
    });
}

function GetJobRun(id) {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + jwtToken }
    return service({
        url: constants.api.run.getJobrun + id,
        method: 'GET',
        headers: headers,
        data: ''
    });
}
/**
 * Get run by its Id
 * @param {Run} id 
 */
function GetRunById(id) {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + jwtToken }
    return service({
        url: constants.api.run.getRunById + id,
        method: 'GET',
        headers: headers
    });
}


function Postchat(chatData) {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + jwtToken }
    return service({
        url: constants.api.run.getPostChat,
        method: 'POST',
        headers: headers,
        data: chatData
    });
}

function GetRerun(id) {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + jwtToken }
    return service({
        url: constants.api.run.getRerun + '/' + id,
        method: 'POST',
        headers: headers,
        data: ''
    });
}

function csvDataPagination(udata, start, storageId, rootFolder) {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + jwtToken }
    return service({
        url: constants.api.storage.csvPaginate + "?page=" + start + "&size=" + 100,
        method: 'POST',
        headers: headers,
        data: udata
    });
}

function getParaTable(parameterset) {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + jwtToken }
    return service({
        url: constants.api.run.getTableParaset,
        method: 'POST',
        headers: headers,
        data: { code: parameterset }
    });
}

function GetRunTags(key, page, limit) {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + jwtToken }
    return service({
        url: constants.api.run.getTagsRun + "?key=" + key + "&page=" + page + "&limit=" + limit,
        method: 'GET',
        headers: headers,
        data: ''
    });
}

function GetRunTagsValue(key) {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + jwtToken }
    return service({
        url: constants.api.run.getAutocompleteRun + "?key=" + key,
        method: 'GET',
        headers: headers,
        data: ''
    });
}

function getRunComputeHours() {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + jwtToken }
    return service({
        url: constants.api.run.getComputeHours,
        method: 'GET',
        headers: headers,
        data: ''

    });
}

function getLatestRun() {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + jwtToken }
    return service({
        url: constants.api.run.GetLatestRun,
        method: 'GET',
        headers: headers,
    });
}

function getRunSearch(runData, start, end) {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + jwtToken }
    return service({
        url: constants.api.run.getRunSearch + "?page=" + start + "&size=" + end,
        method: 'POST',
        headers: headers,
        data: runData
    });
}

//To export run function
const RunService = {
    new_runInit, getAllRuns, runSubmit, cancelJob, removeJob, downloadFile, GetChats, Postchat,
    GetRerun, PostRerun, GetJobRun, GetRunById, GetmessageCount, GetMessages, GetmessageOnScroll, ChatUpdateReadStatus, getRunbySize, getRunbySearch,
    createTags, csvDataPagination, getAllRunTimesImage, getParaTable, GetRunTags, GetRunTagsValue, getRunComputeHours, getLatestRun, getRunSearch
}

export default RunService;
